import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import ThumbUpIcon from '@heroicons/react/outline/ThumbUpIcon';
import { hasScopesPermission } from '@tribeplatform/gql-client/lib';
import { useAddReaction, useRemoveReaction, } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { useDelayedDisclosure } from '@tribeplatform/react-ui-kit/hooks';
import { Popover } from '@tribeplatform/react-ui-kit/Popover';
import { IconEmoji } from '../../common/components/IconEmoji';
import { useLogin } from '../../common/hooks/useLogin';
import { useI18n } from '../../i18n';
import { confirmActionOnLockedPost } from '../utils';
export const SingleReactionWithOptions = ({ post, options, mainReactionText, mainReaction, showIcon = true, showText = true, }) => {
    const intl = useI18n();
    const { mutate: removeReaction } = useRemoveReaction();
    const { mutate: addReaction } = useAddReaction();
    const { isLoggedIn, showLogin } = useLogin();
    const selectedReaction = useMemo(() => { var _a; return (_a = post.reactions) === null || _a === void 0 ? void 0 : _a.find(r => options[r.reaction] && r.reacted); }, [post.reactions, options]);
    let disabled = false;
    if (post && isLoggedIn) {
        const [canReact] = hasScopesPermission(post, ['addReaction']);
        if (!canReact || !post.authMemberProps.canReact) {
            disabled = true;
        }
    }
    const onRemoveReaction = useCallback(async (reaction) => {
        if (!(await confirmActionOnLockedPost(intl)(post))) {
            return;
        }
        removeReaction({
            postId: post.id,
            reaction,
        });
    }, [removeReaction, post, intl]);
    const onAddReaction = useCallback(reaction => async (e) => {
        if (!isLoggedIn) {
            e.preventDefault();
            return showLogin();
        }
        if (!(await confirmActionOnLockedPost(intl)(post))) {
            return;
        }
        addReaction({
            postId: post === null || post === void 0 ? void 0 : post.id,
            input: {
                reaction,
            },
        });
    }, [post, addReaction, showLogin, isLoggedIn, intl]);
    const [active, { open, close }] = useDelayedDisclosure();
    const leadingIcon = selectedReaction ? (_jsx("div", { className: "h-6 w-6 flex items-center shrink-0", children: _jsx(IconEmoji, { text: selectedReaction.reaction, size: "md" }, void 0) }, void 0)) : (_jsx(ThumbUpIcon, { className: "w-6 h-6 transition-transform group-hover:-rotate-6 shrink-0" }, void 0));
    const activator = (_jsx(Button, { variant: "outline", className: "group select-none", size: "md", fullWidth: true, disabled: disabled, leadingIcon: showIcon ? leadingIcon : null, onClick: e => {
            e.preventDefault();
            if (selectedReaction) {
                onRemoveReaction(selectedReaction.reaction);
            }
            else {
                onAddReaction(mainReaction)(e);
            }
        }, onTouchStart: () => {
            if (!disabled) {
                open();
            }
        }, onMouseEnter: () => {
            if (!disabled) {
                open();
            }
        }, onMouseLeave: close, children: showText && (_jsx("div", { className: "truncate", children: selectedReaction
                ? options[selectedReaction.reaction]
                : mainReactionText }, void 0)) }, void 0));
    return (_jsx(Popover, { activator: activator, open: active, onClose: close, placement: "top", padding: "sm", className: "flex-1 flex group", wrapperClassName: "flex-1 min-w-0", rounded: true, children: _jsx(Popover.Content, { onMouseEnter: open, onMouseLeave: close, children: _jsx("div", { className: "flex space-s-2", children: Object.keys(options).map(id => (_jsx("button", { type: "button", className: "cursor-pointer w-12 h-12 flex justify-center items-center transform transition-transform hover:scale-125", children: _jsx(IconEmoji, { text: id, onClick: event => {
                            event.stopPropagation();
                            close();
                            if (selectedReaction) {
                                onRemoveReaction(selectedReaction.reaction);
                            }
                            onAddReaction(id)(event);
                        }, size: "lg" }, void 0) }, id))) }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=SingleReactionWithOptions.js.map